import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const OrderCancelled = () => {
  const { orderId, productId } = useParams();
  
  const [product, setProduct] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id && orderId && productId) {
      fetchOrderDetails();
    } else {
      setLoading(false);
    }
  }, [orderId, productId]);

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_new_order",
        { user_id }
      );

      if (res.data.status === "true" || res.data.status === true) {
        const orders = res.data.data || [];
        const order = orders.find(o => o.order_id == orderId);
        
        if (order && order.items) {
          const productItem = order.items.find(item => item.product_id == productId);
          
          if (productItem) {
            setProduct(productItem);
            setOrderInfo(order);
          }
        }
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container py-5 text-center" style={{ marginTop: "115px" }}>
        <h5>Loading order details...</h5>
      </div>
    );
  }

  if (!product || !orderInfo) {
    return (
      <div className="container py-5 text-center" style={{ marginTop: "115px" }}>
        <h5>Order not found</h5>
      </div>
    );
  }

  return (
    <div className="order-page" style={{ marginTop: "115px" }}>
      <div className="order-wrapper">
        {/* LEFT */}
        <div className="order-left">
          <div className="order-card">
            {/* PRODUCT HEADER */}
            <div className="product-header">
              <div>
                <h5>{product.product_name}</h5>
                <p className="muted">{product.color || "N/A"}</p>
                <p className="muted">Seller: {product.seller_name || "Unknown"}</p>
                <h4>₹{product.subtotal || (product.price * product.qty)}</h4>
              </div>
              
              <div className="product-image">
              <img
                src={
                  product.multi_image
                    ? `https://cyberathon.com/multivendor/${product.multi_image}`
                    : "https://via.placeholder.com/150"
                }
                alt={product.product_name}
              />
            </div>
            </div>

            <hr />

            {/* STATUS */}
            <div className="status-box">
              <div className="status-row confirmed">
                <span className="icon green">✓</span>
                <p>Order Confirmed, {new Date(orderInfo.order_date).toLocaleDateString('en-US', { 
                  day: 'numeric', 
                  month: 'short' 
                })}</p>
              </div>

              <div className="status-line"></div>

              <div className="status-row cancelled">
                <span className="icon red">✕</span>
                <p>Cancelled, {new Date().toLocaleDateString('en-US', { 
                  day: 'numeric', 
                  month: 'short' 
                })}</p>
              </div>
            </div>

            <a href="#" className="updates-link">
              See All Updates →
            </a>
          </div>

          {/* FEEDBACK */}
          {/* <div className="feedback-card">
            <h4>Rate your experience</h4>

            <div className="feedback-row">
              🛒 How was your cancellation experience?
              <span>›</span>
            </div>

            <div className="feedback-row">
              👍 Did you find this page helpful?
              <span>›</span>
            </div>
          </div> */}
        </div>

        {/* RIGHT */}
        <div className="order-right">
          <div className="side-card">
            <h4>Delivery details</h4>

            <div className="info-box">
              <p>
                🏠 <strong>{orderInfo.address_type || "Home"}</strong>{" "}
                {orderInfo.address || "Address not available"}
              </p>
              <p>
                👤 <strong>{orderInfo.customer_name || "N/A"}</strong>{" "}
                {orderInfo.mobile || "N/A"}
              </p>
            </div>
          </div>

          <div className="side-card">
            <h4>Price details</h4>

            <div className="price-row">
              <span>Listing price</span>
              <span className="strike">₹{product.mrp || product.price}</span>
            </div>

            <div className="price-row">
              <span>Selling price</span>
              <span>₹{product.price}</span>
            </div>

            <div className="price-row">
              <span>Total fees</span>
              <span>₹{product.tax || 0}</span>
            </div>

            <hr />

            <div className="price-row total">
              <span>Total amount</span>
              <span>₹{product.subtotal || (product.price * product.qty)}</span>
            </div>

            <div className="payment-box">
              Payment method <strong>{orderInfo.payment_method || "Cash On Delivery"}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCancelled;